export function toRadians(degrees) {
  return (degrees * Math.PI) / 180
}

export function throttleScrollDelta(event, to = 10) {
  const from = event.deltaY

  if (from === 0) return 0

  const isTrackPad = Math.abs(from) < 50 && event.deltaMode === 0

  if (isTrackPad) return from

  const sign = from / Math.abs(from)

  let out = from
  out = Math.abs(out)
  out = Math.min(out, to)
  out = Math.max(out, 1)
  out = isNaN(out) ? 1 : out
  out = sign * out

  return out
}
